import { getWidgetData } from '@/services/widget-data';
import { BankPartner, MerchantFeeTierArray } from '@/services/widget-data/models';
import { Vue } from 'vue-property-decorator';

/*
    Class is used for shared props/attributes.
*/
export abstract class BaseWidget extends Vue {
    componentWidget: HTMLElement;

    get translatorLanguage() {
      const langSelector = this.componentWidget.getAttribute('languageSelector') || this.componentWidget.getAttribute('languageselector');

      if (langSelector && document.querySelector(langSelector)?.getAttribute('lang')) {
        return document.querySelector(langSelector).getAttribute('lang');
      } else if (document.querySelector('html')?.getAttribute('lang')) {
        return document.querySelector('html').getAttribute('lang');
      }
      return '';
    }

    get isWebBankMerchant(): boolean {
      return this.merchantBankPartner === BankPartner.WebBank;
    }

    get merchantBankPartner(): string {
      return getWidgetData().getMerchantBankPartner();
    }

    get merchantFeeTiers(): MerchantFeeTierArray {
      return getWidgetData().getMerchantFeeTiers();
    }

    get isFeeMerchant(): boolean {
      return this.merchantFeeTiers.length > 0;
    }

    get merchantName(): string {
      return getWidgetData().getMerchantName();
    }
}
